module.exports = __webpack_public_path__ + "static/media/std-testing-first-lithonia-medical-center.a8944584.jpg";